import { Box } from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DefaultHeaderCell } from "components/table-v2/header-cells";
import { DefaultRowCell } from "components/table-v2/row-cells";
import { ITableV2Column } from "components/table-v2/table-v2";
import { TLeadIconConfig } from "types/lead-icon.type";
import { getLeadTypeLabel } from "utils/lead-type.utils";
import { LEAD_ICON_MAP, LEAD_ICON_LABELS } from "constants/lead-icons";
import { LeadIconsTableActionCell } from "./LeadIconsTableActionCell";

export const leadIconsColumnDef = (
  getSourceLabel: (source: string) => string,
  handleEdit: (row: TLeadIconConfig) => () => void,
  handleRemove: (row: TLeadIconConfig) => () => void
): ITableV2Column<TLeadIconConfig>[] => {
  return [
    {
      accessor: "source",
      Header: <DefaultHeaderCell>Source</DefaultHeaderCell>,
      Cell: ({ row }) => (
        <DefaultRowCell>{getSourceLabel(row.source)}</DefaultRowCell>
      ),
    },
    {
      accessor: "type",
      Header: <DefaultHeaderCell>Type</DefaultHeaderCell>,
      Cell: ({ row }) => (
        <DefaultRowCell>
          <Box textTransform={"capitalize"}>{getLeadTypeLabel(row.type)}</Box>
        </DefaultRowCell>
      ),
    },
    {
      accessor: "icon",
      Header: <DefaultHeaderCell>Icon</DefaultHeaderCell>,
      Cell: ({ row }) => {
        const icon = LEAD_ICON_MAP[row.icon];
        return (
          <DefaultRowCell>
            <Box display={"flex"} alignItems={"center"} gap={2}>
              {icon && (
                <Box color={icon.color}>
                  <FontAwesomeIcon icon={icon.icon} fontSize={"18px"} />
                </Box>
              )}
              <Box>{LEAD_ICON_LABELS[row.icon]}</Box>
            </Box>
          </DefaultRowCell>
        );
      },
    },
    {
      accessor: "id",
      width: "70px",
      disableSortBy: true,
      excludeFromGlobalFilter: true,
      Header: null,
      Cell: ({ row }) => (
        <LeadIconsTableActionCell
          handleEdit={handleEdit(row)}
          handleRemove={handleRemove(row)}
        />
      ),
    },
  ];
};
